(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesController', TabDevicesTypesController);

    TabDevicesTypesController.$inject = ['$scope', '$state', 'TabDevicesTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabDevicesTypesController ($scope, $state, TabDevicesTypes, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabDevicesTypes = [];
        //vm.predicates = {};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.currentState = "tab-devices-type";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {

            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
            }

            TabDevicesTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabDevicesTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabDevicesTypes.push(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.tabDevicesTypes = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

    }
})();
